import { Module } from 'vuex'
import actions from '@/store/from_addresses/actions'
import mutations from '@/store/from_addresses/mutations'
import { FromAddressesStateInterface } from '@/models/store/FromAddressesState.interface'
import { RootStateInterface } from '@/models/store/RootState.interface'

export const initState = (): FromAddressesStateInterface => ({
  fromAddresses: [],
  loading: false,
  saving: false
})

const fromAddressesModule: Module<
  FromAddressesStateInterface,
  RootStateInterface
> = {
  namespaced: true,
  state: initState(),
  actions,
  mutations
}

export default fromAddressesModule
